import * as models from '../../domain/models';
import * as actions from '../actions/integration-status-detail';
import * as _ from 'lodash';

export interface State {
  isLoaded: boolean;
  isLoading: boolean;
  item: models.IntegrationStatus;
}

const initialState: State = {
  isLoaded: false,
  isLoading: false,
  item: new models.IntegrationStatus(),
};

export function reducer(state = initialState, action: actions.Actions): State {
  switch (action.type) {
    case actions.LOAD: {
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
      };
    }

    case actions.LOAD_SUCCESS: {
      const item = _.cloneDeep(action.payload.item);
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        item,
      };
    }

    case actions.LOAD_FAIL: {
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
      };
    }

    case actions.RESET: {
      return {
        ...state,
        isLoading: false,
        isLoaded: false,
        item: new models.IntegrationStatus(),
      };
    }

    default: {
      return state;
    }
  }
}

export const getIsLoaded = (state: State) => state.isLoaded;
export const getIsLoading = (state: State) => state.isLoading;
export const getItem = (state: State) => state.item;